/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDroplet: {
  name: 'droplet';
  data: string;
} = {
  name: 'droplet',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 5.175c-.778.502-2.29 1.56-3.608 2.965C7.02 9.602 6 11.286 6 13c0 3.435 2.674 6 6 6s6-2.565 6-6c0-1.714-1.02-3.398-2.392-4.86-1.319-1.405-2.83-2.463-3.608-2.965Zm-1.024-1.72a1.893 1.893 0 0 1 2.048 0c.825.529 2.531 1.707 4.042 3.317C18.556 8.358 20 10.519 20 13c0 4.565-3.594 8-8 8-4.406 0-8-3.435-8-8 0-2.481 1.444-4.642 2.934-6.228 1.51-1.61 3.217-2.788 4.042-3.316Z" fill="currentColor"/></svg>`,
};
